import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Loader2, X, Plus } from 'lucide-react';

export const WizardStepVariants = ({ variants, setVariants, onExecute, onBack, loading }) => {
    const [manualVariant, setManualVariant] = useState('');

    const removeVariant = (v) => {
        setVariants(prev => prev.filter(item => item !== v));
    };

    const addManual = () => {
        const cleaned = manualVariant.trim().toLowerCase();
        if (cleaned && !variants.includes(cleaned) && variants.length < 10) {
            setVariants(prev => [...prev, cleaned]);
        }
        setManualVariant('');
    };

    return (
        <div className="space-y-6">
            <div className="mb-4">
                <p className="text-sm font-medium text-gray-700 mb-2">Variantes a buscar en el IMPI (Máx 10)</p>
                {variants.length === 0 ? (
                    <div className="bg-yellow-50 text-yellow-800 p-4 rounded-md border border-yellow-200 text-sm">
                        No se lograron generar ramificaciones fonéticas distintivas. El análisis procederá únicamente con la búsqueda de coincidencia exacta.
                    </div>
                ) : (
                    <div className="flex flex-col gap-2">
                        {variants.map(v => (
                            <div
                                key={v}
                                className="flex items-center justify-between bg-indigo-50 border border-indigo-200 text-indigo-800 px-4 py-3 rounded-lg text-sm transition"
                            >
                                <span className="font-semibold">{v}</span>
                                <button
                                    onClick={() => removeVariant(v)}
                                    className="text-indigo-400 hover:text-indigo-700 transition"
                                    aria-label="Remove"
                                >
                                    <X className="h-5 w-5" />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {variants.length < 10 && (
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                    <p className="text-sm font-medium text-gray-700 mb-2">Añadir variante manual</p>
                    <div className="flex flex-col sm:flex-row items-center gap-2">
                        <input
                            type="text"
                            value={manualVariant}
                            onChange={(e) => setManualVariant(e.target.value)}
                            placeholder="Ej: starcaffe"
                            className="w-full px-4 py-2 bg-white border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500"
                        />
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={addManual}
                            disabled={!manualVariant.trim()}
                            className="bg-white border hover:bg-gray-100 text-gray-700 whitespace-nowrap"
                        >
                            <Plus className="h-4 w-4 mr-2" />
                            Agregar
                        </Button>
                    </div>
                </div>
            )}

            <div className="pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
                <Button
                    variant="outline"
                    onClick={onBack}
                    disabled={loading}
                    className="w-full md:w-auto"
                >
                    Retroceder revisón
                </Button>
                <Button
                    onClick={onExecute}
                    disabled={loading || variants.length === 0}
                    className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white min-w-[120px]"
                >
                    {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
                    {loading ? 'Inicializando...' : 'Ejecutar Análisis'}
                </Button>
            </div>
        </div>
    );
};
